var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlookIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4994 3H11.4999C10.5335 3 9.75 3.78347 9.75 4.74994V25.7492C9.75 26.7157 10.5335 27.4991 11.4999 27.4991H25.4994C26.4659 27.4991 27.2494 26.7157 27.2494 25.7492V4.74994C27.2494 3.78347 26.4659 3 25.4994 3Z",
    fill: "#1066B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4994 3H11.4999C10.5335 3 9.75 3.78347 9.75 4.74994V25.7492C9.75 26.7157 10.5335 27.4991 11.4999 27.4991H25.4994C26.4659 27.4991 27.2494 26.7157 27.2494 25.7492V4.74994C27.2494 3.78347 26.4659 3 25.4994 3Z",
    fill: "url(#paint0_linear_18444_2116)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4997 5.62695H9.75V14.3766H18.4997V5.62695Z",
    fill: "#32A9E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4997 14.375H9.75V23.1247H18.4997V14.375Z",
    fill: "#167EB4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2487 14.375H18.499V23.1247H27.2487V14.375Z",
    fill: "#32A9E7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2487 5.62695H18.499V14.3766H27.2487V5.62695Z",
    fill: "#58D9FD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18444_2116",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 13,
    width: 21,
    height: 15
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00098 13.5H27.2503C28.2168 13.5 29.0002 14.2834 29.0002 15.2499V25.7496C29.0002 26.7161 28.2168 27.4995 27.2503 27.4995H9.75092C8.78445 27.4995 8.00098 26.7161 8.00098 25.7496V13.5Z",
    fill: "url(#paint1_linear_18444_2116)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18444_2116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9999 13.5V16.9999H27.25V13.5H28.9999Z",
    fill: "#135298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0002 27.4996V15.25L7.12598 27.4996H29.0002Z",
    fill: "url(#paint2_linear_18444_2116)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00098 27.4996V15.25L29.8752 27.4996H8.00098Z",
    fill: "url(#paint3_linear_18444_2116)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.7499C8 10.3002 9.17522 9.125 10.6249 9.125H15.8747C17.3245 9.125 18.4996 10.3002 18.4996 11.7499V22.2495C18.4996 23.6993 17.3245 24.8744 15.8747 24.8744H8V11.7499Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9995 7.375H2.74994C1.78347 7.375 1 8.15847 1 9.12494V21.3745C1 22.341 1.78347 23.1244 2.74994 23.1244H14.9995C15.966 23.1244 16.7494 22.341 16.7494 21.3745V9.12494C16.7494 8.15847 15.966 7.375 14.9995 7.375Z",
    fill: "url(#paint4_linear_18444_2116)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2497 15.3105V15.165C13.2497 12.6444 11.4361 10.875 8.88869 10.875C6.32747 10.875 4.5 12.6564 4.5 15.1892V15.3347C4.5 17.8553 6.31362 19.6247 8.87485 19.6247C11.4222 19.6247 13.2497 17.8433 13.2497 15.3105ZM11.1869 15.3347C11.1869 17.007 10.2455 18.0129 8.88869 18.0129C7.53193 18.0129 6.57667 16.9828 6.57667 15.3105V15.165C6.57667 13.4926 7.51809 12.4868 8.87485 12.4868C10.2177 12.4868 11.1869 13.5169 11.1869 15.1892V15.3347Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18444_2116",
    x1: 9.75,
    y1: 15.2496,
    x2: 27.2494,
    y2: 15.2496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#064484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F65B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18444_2116",
    x1: 8.00098,
    y1: 24.6727,
    x2: 29.0002,
    y2: 24.6727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B366F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2657B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18444_2116",
    x1: 29.0002,
    y1: 21.3748,
    x2: 8.00095,
    y2: 21.3748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44DCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#259ED0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_18444_2116",
    x1: 8.00098,
    y1: 21.3748,
    x2: 29.0002,
    y2: 21.3748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#259ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44DCFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_18444_2116",
    x1: 1,
    y1: 15.2497,
    x2: 16.7494,
    y2: 15.2497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#064484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F65B5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlookIcon);
export default __webpack_public_path__ + "static/media/OutlookIcon.e4029d6b14e816bb198e9dae7d246384.svg";
export { ForwardRef as ReactComponent };